import type { ICellProps } from '@creditflowresearch/uilib/Table/DataTable';
import { TruncatedTextCell, TruncatedDictionaryCell } from '@/creditflowresearch/ui/common/components/DataCells';
import LeadsCell, { type TLeadField } from '@/creditflowresearch/ui/components/bondscreener/Cells/LeadsCell';
import type { IColumnRendererEntry } from '@/creditflowresearch/ui/common/components/DataTable/columns';

export interface IColumnSize {
  width?: number,
  minWidth?: number,
  maxWidth?: number,
}

export const truncatedEntry = (field: string, size?: IColumnSize): IColumnRendererEntry => ({
  dataType: 'text',
  width: size?.width ?? 120,
  minWidth: size?.minWidth ?? 100,
  maxWidth: size?.maxWidth ?? 180,
  cellCallback: ({ row }: ICellProps) => (<TruncatedTextCell value={ row[field] } />),
});

export const truncatedDictionaryEntry = (
  field: string,
  dictionaryKey: string,
  size?: IColumnSize,
): IColumnRendererEntry => ({
  dataType: 'text',
  width: size?.width ?? 100,
  minWidth: size?.minWidth ?? 80,
  maxWidth: size?.maxWidth ?? 150,
  cellCallback: ({ row }: ICellProps) => (
    <TruncatedDictionaryCell id={ row[field] } dictionaryKey={ dictionaryKey } />
  ),
});

export const leadsEntry = (field: TLeadField, size?: IColumnSize): IColumnRendererEntry => ({
  dataType: 'text',
  width: size?.width ?? 100,
  minWidth: size?.minWidth ?? 80,
  maxWidth: size?.maxWidth ?? 150,
  cellCallback: ({ row }: ICellProps) => (<LeadsCell row={ row } field={ field } />),
});
